module.exports = __webpack_public_path__ + "fonts/InstagramSans-Regular.ca0e7cfd.ttf";